import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Check = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7372 7.67567L10.7502 16.3887L5.34921 11.7592L6.6508 10.2407L10.5831 13.6112L17.2628 6.32422L18.7372 7.67567Z"
      fill="currentColor"
    />
  </Icon>
));

export default Check;
